import React, { useEffect, useState } from 'react';
import cn from '@/utils/cn';
import Spinner from '@/components/common/Modal/Spinner';
import TotalPointsRow from '@/components/student/AssignmentsBasedGradesTable/TotalPointsRow';
import { sortTableData, TABLE_ROW_CLASS } from '../utils';
import TableRow from './TableRow';
import TableHeader from './TableHeader';
import useGradesTableStore from '../store/useGradesTableStore';
import useStudentTableData from '../hooks/useStudentTableData';

type SortState = {
  key: string;
  order: 'asc' | 'desc';
};

const Table = () => {
  useStudentTableData();

  const isLoading = useGradesTableStore(state => state.isLoading);
  const tableData = useGradesTableStore(state => state.tableData);
  const setStore = useGradesTableStore(state => state.setStore);
  const [sorted, setSorted] = useState<SortState>({ key: 'due_datetime', order: 'asc' });

  useEffect(() => {
    const sortedTableData = sortTableData(sorted.key, tableData, sorted.order);
    setStore({ tableData: sortedTableData });
  }, [!!tableData.length, sorted.key, sorted.order]);

  const handleSort = (key: string) => {
    if (sorted.key !== key) setSorted({ key, order: 'asc' });
    else setSorted({ key, order: sorted.order === 'asc' ? 'desc' : 'asc' });
  };

  if (isLoading) return (<Spinner isLoading={isLoading} />);

  return (
    <table className="tw-border-separate">
      <thead>
        <tr>
          <TableHeader
            className={cn(TABLE_ROW_CLASS, 'tw-w-[30%]')}
            colSortKey="assignment_details.type"
            handleSort={handleSort}
            label="name"
            sorted={sorted}
          />
          <TableHeader
            className="tw-w-[7%]"
            colSortKey="due_datetime"
            handleSort={handleSort}
            label="due_assignment"
            sorted={sorted}
          />
          <TableHeader
            className="tw-w-[7%]"
            colSortKey="submitted_at"
            handleSort={handleSort}
            label="submitted"
            sorted={sorted}
          />
          <TableHeader
            className="tw-w-[14%]"
            colSortKey="status"
            handleSort={handleSort}
            label="status"
            sorted={sorted}
          />
          <TableHeader
            colSortKey="total_score"
            handleSort={handleSort}
            label="score"
            sorted={sorted}
          />
          <th className={cn(TABLE_ROW_CLASS)} />
        </tr>
      </thead>
      <tbody>
        {tableData.map(rowData => <TableRow key={rowData.assignment_id} rowData={rowData} />)}
      </tbody>
      <tfoot>
        <TotalPointsRow />
      </tfoot>
    </table>
  );
};

export default Table;
